import React, { useState } from "react";
import { Check } from "lucide-react";
import { useLang } from "@/i18n";
import { useSettings } from "@/lib/settings";

export default function PricingSection() {
  const { t } = useLang();
  const s = useSettings();
  const [hours, setHours] = useState(1);
  const rate = s.base_hourly_price;
  return (
    <section id="pricing" className="chela-section">
      <div className="chela-container">
        <span className="eyebrow">{t("pr_eyebrow")}</span>
        <h2 className="mt-4 font-display font-bold tracking-tight text-3xl sm:text-4xl lg:text-5xl text-[#121316]">{t("pr_h2")}</h2>
        <div className="mt-12 grid lg:grid-cols-12 gap-8">
          <div className="lg:col-span-7">
            <div data-testid="pricing-table" className="chela-card rounded-3xl overflow-hidden" style={{ transform: "none" }}>
              <div data-testid="price-row-standard" className="flex items-center justify-between gap-4 px-6 py-5 bg-[#FFF1EC]">
                <span className="font-semibold text-[#121316]">{t("pr_standard")}</span>
                <span className="font-display font-bold text-xl text-[#121316]">{s.currency}{rate}{t("per_hour")}</span>
              </div>
            </div>
            <ul data-testid="pricing-rules" className="mt-6 space-y-2.5">
              {["pr_rule_1", "pr_rule_2", "pr_rule_3", "pr_rule_4"].map((r) => (
                <li key={r} className="flex items-start gap-2.5 text-sm text-[#3A3D45]">
                  <Check size={16} className="text-[#E05624] mt-0.5 shrink-0" /> {t(r)}
                </li>
              ))}
            </ul>
          </div>
          <div className="lg:col-span-5">
            <div data-testid="price-calculator" className="chela-card rounded-3xl p-6 sm:p-7" style={{ transform: "none" }}>
              <h3 className="font-display font-bold text-xl text-[#121316]">{t("pr_calc_title")}</h3>
              <label className="block mt-5"><span className="block text-sm font-bold text-[#121316] mb-1.5">{t("pr_hours")}</span>
                <select data-testid="calc-hours" value={hours} onChange={(e) => setHours(Number(e.target.value))} className="w-full h-12 px-4 rounded-xl border border-[#E5E0D8] bg-white text-[#121316] outline-none focus:border-[#E05624]">
                  {[1, 2, 3, 4, 5, 6, 7, 8].map((h) => <option key={h} value={h}>{h}</option>)}
                </select></label>
              <div className="mt-6 flex items-end justify-between gap-4 border-t border-[#E5E0D8] pt-5">
                <span className="text-sm text-[#5A5D65]">{hours} × {s.currency}{rate}</span>
                <span data-testid="calc-total" className="font-display font-extrabold text-4xl text-[#E05624]">{s.currency}{rate * hours}</span>
              </div>
              <p data-testid="calc-offer" className="mt-4 text-sm font-bold text-[#1B8A4B] bg-[#E9F7EF] rounded-xl px-4 py-2.5">
                {hours >= 2 ? `${t("offer_first")}: ${s.currency}${rate * (hours - 1)}` : t("offer_line")}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
